// QuoteEdit.jsx - Main component
import React, { useState } from 'react';
import { Box, Tabs } from '@mantine/core';
import HeaderTab from './HeaderTab';
import LinesTab from './LinesTab/LinesTab';
import ShipBillTab from './ShipBillTab';
import SetupTab from './SetupTab';
import ChargesTab from './ChargesTab';
import TaxesTab from './TaxesTab';
import CommissionTab from './CommissionTab';
import AcctTab from './AcctTab';

const QuoteEdit = () => {
  const [activeTab, setActiveTab] = useState('header');
  
  // Sample data - would come from props or API
  const [quoteData, setQuoteData] = useState({
    quoteNo: '812962',
    quoteType: 'Quotation',
    customerCode: 'DMAS0100',
    customerName: 'DELTA MATERIAL SERVICES',
    attn: '',
    fob: 'ORG',
    fobLocation: 'ORIGIN',
    shipVia: '',
    terms: '005',
    termsDescription: 'NET 45',
    preparedBy: 'DD',
    preparedByName: 'Derek Deur',
    priority: '',
    ourRef: '',
    yourRef: '',
    bsoOrder: '',
    bCustPO: '',
    docStatus: 'Bid',
    holdBy: '',
    entered: new Date('2025-07-30T08:12:03'),
    reqOn: new Date('2025-07-30T08:12:08'),
    dueOn: new Date('2025-07-30T08:12:09'),
    priced: new Date('2025-07-30T08:12:09'),
    quoted: new Date('2025-07-30T08:12:09'),
    validFor: 30,
    validUntil: new Date('2025-08-29T08:12:09'),
    lastPrint: '',
    revision: '',
    subTotal: 17850.00,
    discount: 0.00,
    miscTtl: 0.00,
    taxTtl: 0.00,
    docTotal: 17850.00,
    cmcyBase: 'USD',
    cmcyConv: 'USD'
  });

  return (
    <Box>
      <Tabs value={activeTab} onChange={setActiveTab}>
        <Tabs.List>
          <Tabs.Tab value="header">Header</Tabs.Tab>
          <Tabs.Tab value="lines">Lines</Tabs.Tab>
          <Tabs.Tab value="shipbill">Ship/Bill</Tabs.Tab>
          <Tabs.Tab value="setup">Setup</Tabs.Tab>
          <Tabs.Tab value="charges">Charges</Tabs.Tab>
          <Tabs.Tab value="taxes">Taxes</Tabs.Tab>
          <Tabs.Tab value="commission">Commission</Tabs.Tab>
          <Tabs.Tab value="acct">Acct</Tabs.Tab>
        </Tabs.List>

        <Tabs.Panel value="header">
          <HeaderTab quoteData={quoteData} setQuoteData={setQuoteData} />
        </Tabs.Panel>

        <Tabs.Panel value="lines">
          <LinesTab quoteData={quoteData} setQuoteData={setQuoteData} />
        </Tabs.Panel>

        <Tabs.Panel value="shipbill">
          <ShipBillTab quoteData={quoteData} setQuoteData={setQuoteData} />
        </Tabs.Panel>

        <Tabs.Panel value="setup">
          <SetupTab quoteData={quoteData} setQuoteData={setQuoteData} />
        </Tabs.Panel>

        <Tabs.Panel value="charges">
          <ChargesTab quoteData={quoteData} setQuoteData={setQuoteData} />
        </Tabs.Panel>

        <Tabs.Panel value="taxes">
          <TaxesTab quoteData={quoteData} setQuoteData={setQuoteData} />
        </Tabs.Panel>

        <Tabs.Panel value="commission">
          <CommissionTab quoteData={quoteData} setQuoteData={setQuoteData} />
        </Tabs.Panel>

        <Tabs.Panel value="acct">
          <AcctTab quoteData={quoteData} setQuoteData={setQuoteData} />
        </Tabs.Panel>
      </Tabs>
    </Box>
  );
};

export default QuoteEdit;











